var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 55h-1v-3a1 1 0 0 0-1-1h-1V27h1a1 1 0 0 0 1-1v-4a.29.29 0 0 0 0-.09.79.79 0 0 0 0-.2l-.06-.17-.11-.15a.67.67 0 0 0-.14-.15l-.06-.06-26-18a1 1 0 0 0-1.14 0l-26 18-.06.06a.67.67 0 0 0-.14.15l-.11.15-.06.17a.79.79 0 0 0 0 .2A.29.29 0 0 0 5 22v4a1 1 0 0 0 1 1h1v24H6a1 1 0 0 0-1 1v3H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-5-4h-2V27h2Zm-12 0V27h8v24Zm-16 0V27h10v24Zm-14 0V27h8v24Zm10-24h2v24h-2Zm16 0h2v24h-2Zm18-2H7v-2h50ZM32 5.22 54.8 21H9.2ZM9 27h2v24H9ZM7 53h50v2H7Zm52 6H5v-2h54Z",
    fill: "#ff7b26",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18h10a1 1 0 0 0 0-2h-1.14a4 4 0 0 0-7.72 0H27a1 1 0 0 0 0 2Zm5-3a2 2 0 0 1 1.72 1h-3.44A2 2 0 0 1 32 15Z",
    fill: "#ff7b26",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.fba43d5e2e45574ed3c6cc41bd01b612.svg";
export { ForwardRef as ReactComponent };